import { Link } from 'react-router-dom';

interface Props {
  /** 마크 한 변 픽셀. text 가 있으면 글자 크기와 시각 균형을 맞춰 전달. */
  size?: number;
  /** 텍스트 동반 여부. false 면 아이콘만 (favicon-like). */
  showText?: boolean;
  /** 클릭 시 이동 경로. 비우면 텍스트 없는 정적 마크. */
  to?: string;
  /** aria-label override. */
  label?: string;
}

/**
 * Alpha Omega Quant — 미니멀 심볼 로고.
 *
 * 도형: Ω 형태의 거의-닫힌 원호 + 상단 정점 위 작은 α 점.
 *   · "한 사이클의 시작과 끝" 시각적 함축 (장전→장중→장후 cycle).
 *   · stroke 1.75, currentColor — 부모 색상(주로 --accent copper) 상속.
 *   · 12~32px 어디서든 식별 가능.
 *
 * 권위: .interface-design/system.md (원장 / Wonjang).
 */
export function Logo({
  size = 22,
  showText = true,
  to = '/',
  label = 'Alpha Omega Quant 홈',
}: Props): JSX.Element {
  const content = (
    <span className="ao-logo">
      <svg
        className="ao-logo__mark"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
        focusable="false"
      >
        {/* Ω: 거의 완전한 원, 상단 정점에 좁은 갭 */}
        <path
          d="M 7.5 5 A 8 8 0 1 0 16.5 5"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          fill="none"
        />
        {/* α: 갭 위 closure 점 */}
        <circle cx="12" cy="2.6" r="1.4" fill="currentColor" />
      </svg>
      {showText && <span className="ao-logo__text">Alpha Omega</span>}
    </span>
  );

  return to ? (
    <Link to={to} className="ao-logo__link" aria-label={label}>
      {content}
    </Link>
  ) : (
    content
  );
}
